export enum Permission {
  ReadYardBlock = 'read:yard-block',
  WriteYardBlock = 'write:yard-block',
  ReadDangerousGoodsSettings = 'read:dangerous-goods-settings',
  WriteDangerousGoodsSettings = 'write:dangerous-goods-settings',
}
